module.exports = __webpack_public_path__ + "img/6.642f7911.gif";